var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCatCompras(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cat_compras",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_15",
    "data-name": "Rect\\xE1ngulo 15",
    width: 200,
    height: 200,
    fill: "#e8eff1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "iconmonstr-shopping-bag-7",
    d: "M23.04,151.933,3,138.346V47.43l20.04,8.7ZM36.4,56.823v96.839l86.841-12.511V44.818ZM76.234,6.4c-14.008,0-26.44,12.837-26.467,27.313l-.007,10.775A3.3,3.3,0,0,0,53.6,47.654a3.248,3.248,0,0,0,2.839-3.163V33.729c.02-10.948,9.459-20.924,19.793-20.924a13.062,13.062,0,0,1,9.245,3.611,15.039,15.039,0,0,1,4.362,11.057V38.659a3.3,3.3,0,0,0,3.841,3.163,3.233,3.233,0,0,0,2.826-3.15l.013-11.2C96.535,15.283,87.7,6.4,76.234,6.4ZM33.548,44.786A3.255,3.255,0,0,0,36.4,41.617V27.326C36.414,16.378,45.86,6.4,56.194,6.4l1.082.1a33.634,33.634,0,0,1,7.936-4.373A20.363,20.363,0,0,0,56.194,0c-14,0-26.44,12.837-26.467,27.313v14.31a3.293,3.293,0,0,0,3.821,3.163Z",
    transform: "translate(36.278 23.05)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatCompras);
export default __webpack_public_path__ + "static/media/cat_compras.39b530742a4ec1c7cf4b91e5510d8504.svg";
export { ForwardRef as ReactComponent };